var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobPost1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.437 28C14.1738 26.4693 13.4169 24.5182 13.4169 22.3933C13.4169 19.9691 14.4019 17.7712 16 16.1656C10.9613 15.592 5.7876 16.5088 1.18039 18.9161C0.454008 19.2956 0 20.0385 0 20.8471V25.6914C0 26.9663 1.05122 28 2.34794 28H15.437Z",
    fill: "#FC573B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9999 0C9.13388 0 6 3.13401 6 6.99994C6 10.866 9.13388 14.0001 12.9999 14.0001C16.8658 14.0001 19.9999 10.866 19.9999 6.99994C19.9999 3.13401 16.8658 0 12.9999 0Z",
    fill: "#FC573B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5001 16.9564C19.4383 16.9564 16.9564 19.4383 16.9564 22.5001C16.9564 25.5616 19.4383 28.0436 22.5001 28.0436C25.5616 28.0436 28.0436 25.5616 28.0436 22.5001C28.0436 19.4383 25.5616 16.9564 22.5001 16.9564ZM15 22.5001C15 18.3578 18.3578 15 22.5001 15C26.6422 15 30 18.3578 30 22.5001C30 26.6422 26.6422 30 22.5001 30C18.3578 30 15 26.6422 15 22.5001Z",
    fill: "#F9AA9D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7157 17.2843C27.3368 16.9052 26.7222 16.9052 26.3432 17.2843L17.2843 26.3431C16.9052 26.7222 16.9052 27.3368 17.2843 27.7158C17.6634 28.0947 18.2779 28.0947 18.657 27.7158L27.7157 18.657C28.0948 18.2779 28.0948 17.6634 27.7157 17.2843Z",
    fill: "#F9AA9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPost1);
export default __webpack_public_path__ + "static/media/job-post1.00ce2879e1b8e4239258fe9e40d2d82c.svg";
export { ForwardRef as ReactComponent };